var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-toggle",
              rawName: "v-b-toggle.sidebar-1",
              modifiers: { "sidebar-1": true }
            }
          ]
        },
        [_vm._v("Toggle Sidebar")]
      ),
      _vm._v(" "),
      _c(
        "b-sidebar",
        {
          attrs: {
            "aria-labelledby": "sidebar-no-header-title",
            "bg-variant": "secondary",
            "is-nav": "",
            "no-header-close": "",
            left: "",
            "text-variant": "primary",
            appear: "",
            "no-close-on-esc": "",
            "no-close-on-route-change": "",
            "no-close-on-backdrop": "",
            visible: false,
            width: "270px",
            shadow: ""
          }
        },
        [
          _c(
            "nav",
            { staticClass: "mb-3" },
            [
              _c(
                "b-nav",
                { attrs: { vertical: "" } },
                [
                  _vm._v("\n        asdasd\n        "),
                  _c("b-nav-item", { attrs: { active: "" } }, [
                    _vm._v("Active")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    { attrs: { to: "/asunto" } },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "route" } }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("global.menu.entities.asunto")
                            )
                          }
                        },
                        [_vm._v("Asunto")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "p-3" },
            [
              _c(
                "h1",
                [
                  _c("router-link", { attrs: { to: "/" } }, [
                    _c("span", { staticClass: "logo" }, [_vm._v("Kbase")])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-dropdown-item",
                { attrs: { to: "/asunto" } },
                [
                  _c("font-awesome-icon", { attrs: { icon: "route" } }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t("global.menu.entities.asunto")
                        )
                      }
                    },
                    [_vm._v("Asunto")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("ul", { staticClass: "list-unstyled components mb-5" }, [
                _vm.authenticated
                  ? _c(
                      "li",
                      { staticClass: "active" },
                      [
                        _c("router-link", { attrs: { to: "/" } }, [
                          _c("span", { staticClass: "fa fa-home mr-3" }),
                          _vm._v(" " + _vm._s(_vm.$t("global.menu.home")) + " ")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }